import React from "react";
import { useQuery } from "@apollo/client";
import { CasesSendReportCaseInfoHeaderContainerSendReportCaseV1Document } from "../../../../../../generated";
import { CaseInfoHeader, CaseInfoHeaderFields } from "../../../../../shared/case-info-header/case-info-header";
import { ComponentQueryLoader } from "../../../../../shared/component-query-loader";

interface CaseInfoHeaderContainerProps {
  caseId: string;
}

export const CaseInfoHeaderContainer: React.FC<CaseInfoHeaderContainerProps> = (
  props
) => {
  const {
    data: applicantDetailData,
    loading: applicantDetailLoading,
    error: applicantDetailError,
  } = useQuery(CasesSendReportCaseInfoHeaderContainerSendReportCaseV1Document, {
    variables: {
      sendReportCaseV1Id: props?.caseId,
    },
    context: {
      headers: {
        "cache-enabled": "true",
      }
    }
  });

  const caseInfoData: CaseInfoHeaderFields = {
    applicant: {
      displayName: applicantDetailData?.sendReportCaseV1?.applicant?.displayName ?? "",
      id: applicantDetailData?.sendReportCaseV1?.applicant?.id ?? "",
    },
    submittedAt: applicantDetailData?.sendReportCaseV1?.submittedAt ?? "",
    lastActivityAt: applicantDetailData?.sendReportCaseV1?.lastActivityAt ?? "",
    expirationEligibleAt: applicantDetailData?.sendReportCaseV1?.expirationEligibleAt ?? "",
    id: applicantDetailData?.sendReportCaseV1?.id
  }

  return (
    <ComponentQueryLoader
      loading={applicantDetailLoading}
      hasData={applicantDetailData}
      error={applicantDetailError}
      hasDataComponent={
        <CaseInfoHeader
          data={caseInfoData} caseType="sendReport"
        />
      }
    />
  );
};
